import { NEWS_STORAGE_KEYS } from "@/lib/localStorageKeys/news";
import type { NewsArticle } from "./stores/useNewsStore";
import {
  writeCache,
  NEWS_CACHE_MAX_BYTES,
} from "@/lib/storage/safeLocalStorage";

/** Newest articles kept on disk. The feed re-syncs from the gateway on connect. */
const MAX_PERSISTED_ARTICLES = 300;

export function loadNewsArticles(): NewsArticle[] {
  if (typeof window === "undefined") return [];

  try {
    const raw = localStorage.getItem(NEWS_STORAGE_KEYS.ARTICLES);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed as NewsArticle[];
  } catch {
    return [];
  }
}

export function saveNewsArticles(articles: NewsArticle[]): void {
  if (typeof window === "undefined") return;

  // Warm-start cache only — the news feed re-syncs on connect. Unbounded, this had reached ~2.3 MB
  // and, with the broker catalog, consumed the whole localStorage quota.
  const trimmed =
    articles.length > MAX_PERSISTED_ARTICLES
      ? articles.slice(0, MAX_PERSISTED_ARTICLES)
      : articles;
  writeCache(
    NEWS_STORAGE_KEYS.ARTICLES,
    JSON.stringify(trimmed),
    NEWS_CACHE_MAX_BYTES
  );
}
